import React, {useState} from 'react'
import {Link, LinkGetProps} from '@reach/router'
import cn from 'classnames'
import {PersonFill, CartFill, Building} from 'react-bootstrap-icons'

import Container from '../Container'
import LogoImg from '../../../images/logo.png'
import {useAuth} from '../../../contexts/UserContext'
import {useCart} from '../../../contexts/CartContext'

interface NavItemProps {
  to: string
  children: React.ReactNode
  className?: string
}

function getNavItemProps({isCurrent}: LinkGetProps) {
  return {
    className: cn('nav-link', {active: isCurrent}),
  }
}

function NavItem({to, children, className}: NavItemProps) {
  return (
    <li className={cn('nav-item px-2 nowrap', className)}>
      <Link to={to} getProps={getNavItemProps}>
        {children}
      </Link>
    </li>
  )
}

export default function Navigation() {
  const {user, company, userCompanies, setCompanyId} = useAuth()
  const {cart} = useCart()
  const [showCompanyDropdown, setShowCompanyDropdown] = useState<boolean>(false)
  const [showNav, setShowNav] = useState(false)

  // FIXME: Make a better, reusable dropdown element

  function toggleCompanyDropdown() {
    setShowCompanyDropdown(!showCompanyDropdown)
  }

  return <>
    <nav className="navbar navbar-expand-lg navbar-dark fixed-top bg-dark">
      <Container size="lg">
        <Link className="navbar-brand" to="/">
          <img src={LogoImg} width="56" height="60" alt="stjornugris-logo" />
        </Link>

        <button
          type="button"
          className="navbar-toggler"
          onClick={() => setShowNav(!showNav)}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className={cn('collapse navbar-collapse', {'show': showNav})}>
          <ul className="navbar-nav mr-auto mb-2 mb-lg-0 font-weight-bold">
            <NavItem to="/verslun/">Vöruflokkar</NavItem>
            <NavItem to="/verslun/vorur/">Vörur</NavItem>
          </ul>

          <ul className="navbar-nav ml-auto mb-2 mb-lg-0">
            {user ? <>
              {!!cart?.lines?.length && (
                <NavItem to="/verslun/karfa/">
                  <CartFill size={24} />
                  <span className="ml-2 badge bg-primary text-dark">{cart.lines.length}</span>
                </NavItem>
              )}

              <NavItem to="/verslun/stillingar/">
                <PersonFill size={24} />
                <small className="pl-2 nowrap d-none d-lg-inline">{user.displayName}</small>
              </NavItem>

              {company && (
                <li className="nav-item px-2 nowrap dropdown">
                  <div className="nav-link align-items-center cursor-pointer" onClick={toggleCompanyDropdown}>
                    <Building size={24} />
                    <small className="pl-2 nowrap d-none d-lg-inline">{company.name}</small>
                  </div>

                  <ul className={cn('dropdown-menu', {show: showCompanyDropdown})}>
                    {userCompanies?.map((c: any) => (
                      <li key={c.id}>
                        <a
                          className="dropdown-item cursor-pointer"
                          onClick={() => {
                            setCompanyId(c.id)
                            setShowCompanyDropdown(false)
                          }}
                        >
                          {c.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </li>
              )}
            </> : (
              <NavItem to="/innskraning/">
                <PersonFill size={24} />
              </NavItem>
            )}
          </ul>
        </div>

        {/* <button className="navbar-toggler" type="button">
          <span className="navbar-toggler-icon" />
        </button> */}
      </Container>
    </nav>

    {/* Pusher */}
    <div className="navbar navbar-expand-lg navbar-dark bg-dark" style={{opacity: 0}}>
      <Container size="fluid">
        <Link className="navbar-brand" to="/">
          <img src={LogoImg} width="56" height="60" alt="stjornugris-logo" />
        </Link>
      </Container>
    </div>
  </>
}
